import {
    createRequestCoordinator,
    methods,
    CoordinatorAttributes,
} from '@togglecorp/react-rest-request';

import schema from '#schema';
import { sanitizeResponse } from '#utils/common';

export const serverURL = process.env.REACT_APP_SERVER_URL || 'http://localhost:8009';
export const wsEndpoint = `${serverURL}/api/v1`;

export const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
        const part = parts.pop();
        return part && part.split(';').shift();
    }
    return undefined;
};


const emptyObject = {};
export const alterResponseErrorToFaramError = (errors: { [key: string]: object } = emptyObject) => {
    const {
        nonFieldErrors = [],
        ...formFieldErrors
    } = errors;

    return Object.keys(formFieldErrors).reduce(
        (acc: { [key: string]: object | string }, key: string) => {
            const error = (formFieldErrors)[key];
            acc[key] = Array.isArray(error) ? error.join(' ') : error;
            return acc;
        },
        {
            $internal: nonFieldErrors,
        },
    );
};

export function createConnectedRequestCoordinator<OwnProps>() {
    type Props = OwnProps;

    const requestor = createRequestCoordinator({
        transformParams: (data: CoordinatorAttributes) => {
            const {
                body,
                method,
            } = data;
            const csrftoken = getCookie('csrftoken');
            return {
                method: method || methods.GET,
                body: JSON.stringify(body),
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json; charset=utf-8',
                    'X-CSRFToken': csrftoken,
                },
                credentials: 'include',
            };
        },
        transformProps: (props: Props) => props,
        /*
        transformProps: (props: Props) => {
            const mapStyle = mapStyleSelector(store.getState() as AppState);
            // console.warn('Map style is', mapStyle);
            return props;
        },
        */

        transformUrl: (url: string) => {
            if (/^https?:\/\//i.test(url)) {
                return url;
            }

            return `${wsEndpoint}${url}`;
        },

        transformResponse: (body: object, request: CoordinatorAttributes) => {
            const {
                url,
                method,
                extras: requestOptions,
            } = request;
            const sanitizedResponse = sanitizeResponse(body);

            const extras = requestOptions as { schemaName?: string };
            if (!extras || extras.schemaName === undefined) {
                // NOTE: usually there is no response body for DELETE
                if (method !== methods.DELETE) {
                    console.error(`Schema is not defined for ${url} ${method}`);
                }
            } else {
                try {
                    schema.validate(sanitizedResponse, extras.schemaName);
                } catch (e) {
                    console.error(url, method, sanitizedResponse, e.message);
                    throw (e);
                }
            }

            return sanitizedResponse;
        },

        transformErrors: (response: { errors: { [key: string]: object } }) => {
            // FIXME: handle 404
            const faramErrors = alterResponseErrorToFaramError(response.errors);
            return {
                response,
                faramErrors,
            };
        },

        onFailure: ({ error }) => {
            console.warn('Failure', error);
        },
        onFatal: ({ error }) => {
            console.warn('Fatal', error);
        },
    });

    return requestor;
}

export * from '@togglecorp/react-rest-request';
